export const UPDATE_BLUES_PRICE_TIMEOUT = 30000;
